import React from "react";
import "./style.css";
import {Image} from "../../../../../components/Image";

export const PcOtherBenefits = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  return (
    <div className="other-benefits-pc" data-model-id="16867:8663">
      <div className="contents">

        <div className="container">
          <div className="image-container">
            <div className="word">
              <div className="icon-and-text">
                <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Flexed biceps.png'} width={54} height={54} className={'icon-instance-node'} />
                <div className="text-wrapper">Reduced risk of diabetes</div>
              </div>

              <div className="div">
                <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Anatomical heart.png'} width={54} height={54} className={'icon-instance-node'} />
                <div className="text-wrapper">Normal blood pressure</div>
              </div>

              <div className="div">
                <Image src={'/static/image/questionnaire/weight-loss/otherBenefits/Leafy green.png'} width={54} height={54} className={'icon-instance-node'} />
                <div className="text-wrapper">Balanced cholesterol levels</div>
              </div>
            </div>
          </div>

          <div className="text-container">
            <p className="p">
              Healthy eating can help you achieve your goal and has other
              benefits:
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};
